<template lang='pug' src='./blog.pug'></template>

<script>
import Title from 'components/block/block-title/block-title'

export default {
  computed: {
    props () {
      return this.$store.state.blogArray
    }
  },
  components: {
    Title
  }
}
</script>



// WEBPACK FOOTER //
// blog.vue?b59ccedc